// the routes App.vue renders without the app chrome (no navbar, no login
// redirect): standalone boards, passenger maps, public forms. App.vue's
// created() used to spell the whole condition inline; it now calls
// isChromelessPath so the build watcher (utils/build_watcher_install.js)
// and the update nudge share the same answer. behaviour is identical to the
// inline condition, including the hash checks that run before $route has
// resolved on first paint.

// prefix matches against $route.fullPath
export const CHROMELESS_ROUTE_PREFIXES = [
  '/driver-contacts',
  '/vehicle-util-monthly-tbn',
  '/driver-util-monthly-tbn',
  '/driver-util-monthly-cm',
  '/bus-tracker',
  '/arr-dep',
  '/sos_map',
  '/sos_dispatch',
  '/drivermap',
  '/vehicle-track',
  '/fleet-track', // also covers /fleet-track-fabbus
  '/booking-track',
  '/map-link/',
  '/register',
  '/status',
  '/vsm',
  '/veh-maint-summary',
  '/veh-defects',
  '/fleet-track-fabbus',
  '/booking-customer-map',
  '/op/',
  '/sos/',
]

// exact matches against $route.path: a prefix here would sweep in
// /map-link/, /maps-other or /sos_map's siblings
export const CHROMELESS_EXACT_PATHS = ['/map', '/sos']

export function isChromelessPath(routePath, hashPath, routeBasePath) {
  const rp = routePath || ''
  const hp = hashPath || ''
  const bp = routeBasePath || ''
  if (CHROMELESS_ROUTE_PREFIXES.some(prefix => rp.startsWith(prefix))) return true
  if (CHROMELESS_EXACT_PATHS.includes(bp)) return true
  // raw window.location.hash, for the first paint before $route resolves
  return hp === '/map' || hp.startsWith('/map?') || hp.startsWith('/fleet-track-fabbus')
}
